import { logger } from '../utils';
import axios from './axiosService';
import { RootService } from './rootService';

/**
 * Общий сервис для работы ссо
 */
export class CommonService {
    /**
     * Корневой Web Api сервис.
     */
    private readonly rootService: RootService;

    /**
     * Конструктор.
     * @param rootService корневой Web Api сервис.
     */
    constructor(rootService: RootService) {
        this.rootService = rootService;
    }
}
